import { ip_back } from "../config";

function authHeaders() {
  const token =
    (typeof window !== "undefined" && localStorage.getItem("token")) || "";
  return token
    ? { Authorization: token, "Content-Type": "application/json" }
    : { "Content-Type": "application/json" };
}

async function parseJson(resp) {
  try {
    return await resp.json();
  } catch {
    return {};
  }
}

/**
 * Start session bake + stroke batch (or report tables needing calibration).
 * Optional poseFps / players come from Video analysis settings (default A @ 30fps).
 */
export async function startSessionProcessVideos(
  tsId,
  { resume = false, poseFps = 30, players = "A" } = {}
) {
  const body = {
    ts_id: tsId,
    resume: resume ? 1 : 0,
    players: players || "A",
  };
  const fps = Number(poseFps);
  if (Number.isFinite(fps) && fps > 0) {
    body.pose_fps = fps;
  }
  const resp = await fetch(`${ip_back}api/mobileAPI/sessionProcessVideos`, {
    method: "POST",
    headers: authHeaders(),
    body: JSON.stringify(body),
  });
  const json = await parseJson(resp);
  if (!resp.ok || json?.status === false) {
    throw new Error(json?.message || "Could not start session video processing");
  }
  return json.data;
}

export async function pollSessionProcessVideos({ batchId, tsId }) {
  const qs = new URLSearchParams();
  if (batchId) qs.set("batch_id", batchId);
  if (tsId) qs.set("ts_id", tsId);
  const resp = await fetch(
    `${ip_back}api/mobileAPI/sessionProcessVideos?${qs.toString()}`,
    { method: "GET", headers: authHeaders() }
  );
  const json = await parseJson(resp);
  if (!resp.ok || json?.status === false) {
    throw new Error(json?.message || "Could not poll session processing");
  }
  return json.data;
}
